import axios from 'axios'


function setToken(newToken) {
  sessionStorage.setItem('token', newToken)
}

export function getToken() {
  return sessionStorage.getItem('token')
}

async function createAxiosInstance() {
  const token = getToken()
  
  // baseURL: 'http://localhost:8080',
  return axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
      'Authorization': token
    },
  })
}

export const setAuthToken = async (token) => {
  const axiosCustom = await createAxiosInstance()

  if(token){
    setToken(token)
    axiosCustom.defaults.headers['Authorization'] = `${token}`
  } else{
    setToken(null)
    delete axiosCustom.defaults.headers['Authorization']
  }  
}

export default createAxiosInstance
